import { FC, ReactNode } from 'react'
import useLocale from '@/utils/useLocale'
import Image from 'next/image'
import { Space, Button, Popover, Tooltip } from '@arco-design/web-react'
import IconRefresh from '@/assets/ic_refresh.png'
import IconQrcode from '@/assets/ic_qrcode.png'
import IconLink from '@/assets/ic_link_dark.png'
import QRCode from 'qrcode.react'
import styles from './style/header.module.less'
import IconPlus from '@/assets/ic_plus.svg'
import useCollectBtn from '@/hooks/useCollectBtn'
import useShareBtn from '@/hooks/useShareBtn'

type Props = {
  type?: string
  onRefresh?: () => void
  onClick?: () => void
  updateTime: string
  profileUrl: string
  creativeCenterUrl?: string
  collectBtnHook?: ReturnType<typeof useCollectBtn>
  extraButton?: ReactNode
  hideQrcode?: boolean
  addVideoClick?: () => void
}

const DetailsOperation: FC<Props> = ({
  type,
  onRefresh,
  updateTime,
  profileUrl,
  creativeCenterUrl,
  onClick,
  collectBtnHook,
  extraButton,
  hideQrcode,
  addVideoClick
}) => {
  const t = useLocale()
  const shareBtnHook = useShareBtn()

  return (
    <Space size={16}>
      {type === 'product' && extraButton}
      {/* 分享 */}
      {type !== 'shop' && shareBtnHook.renderForOperation()}

      {/* 刷新 */}
      {onRefresh && (
        <Tooltip mini content={t['influencer.detail.refresh']}>
          <div onClick={onRefresh} className={styles['action-btn']}>
            <Image src={IconRefresh?.src} width={20} height={20} alt="refresh" />
          </div>
        </Tooltip>
      )}

      {/* Open In Creative Center链接 */}
      {type === 'hashtag' && (
        <Tooltip mini content={t['hashtag.detail.creative_center_url']}>
          <div
            className={styles['action-btn']}
            onClick={() => {
              creativeCenterUrl && window.open(`${creativeCenterUrl}`)
            }}
          >
            <Image src={IconLink?.src} width={20} height={20} alt="link" />
          </div>
        </Tooltip>
      )}

      {/* 链接 */}
      {type !== 'shop' && (
        <Tooltip mini content={t['influencer.detail.tiktokLink']}>
          <div
            className={styles['action-btn']}
            onClick={() => {
              window.open(`${profileUrl}`)
            }}
          >
            <Image src={IconLink?.src} width={20} height={20} alt="link" />
          </div>
        </Tooltip>
      )}

      {/* 二维码 */}
      {hideQrcode ? null : (
        <Tooltip mini content={t['influencer.detail.tiktokQrcode']}>
          <Popover
            title=""
            position={'bottom'}
            content={
              <QRCode
                value={profileUrl}
                size={100} // 二维码的大小
                fgColor="#333333"
                style={{ margin: 'auto' }}
              />
            }
          >
            <div className={styles['action-btn']}>
              <Image src={IconQrcode?.src} width={20} height={20} alt="qrcode" />
            </div>
          </Popover>
        </Tooltip>
      )}

      {collectBtnHook?.renderForOperation()}
      {onClick && (
        <Tooltip content={t['menu.live.monitor_button']}>
          <Button className={styles['add-btn']} type="primary" icon={<IconPlus />} onClick={onClick}>
            {t['influencer.monitor.new']}
          </Button>
        </Tooltip>
      )}
      {addVideoClick && (
        <Tooltip content={t['menu.video.monitor_button']}>
          <Button className={styles['add-btn']} type="primary" icon={<IconPlus />} onClick={addVideoClick}>
            {t['monitor.video']}
          </Button>
        </Tooltip>
      )}
    </Space>
  )
}

export default DetailsOperation
